import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { financialConditionGenerationStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/styles.ts';

interface ICurrencyTotalsTableProps {
  ariaLabel: string;
  headers: string[];
  rows: Array<{
    key: string;
    values: React.ReactNode[];
  }>;
}

export const CurrencyTotalsTable: React.FC<ICurrencyTotalsTableProps> = ({
  ariaLabel,
  headers,
  rows,
}) => {
  if (!rows.length) {
    return null;
  }

  return (
    <TableContainer sx={financialConditionGenerationStyles.currencyTotalsTable}>
      <Table size="small" aria-label={ariaLabel}>
        <TableHead>
          <TableRow>
            {headers.map((header, index) => (
              <TableCell key={header} align={index === 0 ? 'left' : 'right'}>
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.key}>
              {row.values.map((value, index) => (
                <TableCell key={headers[index]} align={index === 0 ? 'left' : 'right'}>
                  {value}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
